
  import ScreenSize from '@/mixins/ScreenSize';
  import clearableTabIndex from '@/mixins/clearableTabIndex';
  import DialogsBaseSection from '@/components/sections/DialogsBaseSection.vue';

  export default {
    name: 'RequestPasswordForm',
    components: {
      DialogsBaseSection,
    },
    mixins: [clearableTabIndex, ScreenSize],
    props: {
      matomoEventName: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        resetPasswordEmail: '',
        section: {},
      };
    },
    async fetch() {
      this.section = await this.$cachedStrapi
        .find('request-password-dialog')
        .catch((e) => {
          if (e.statusCode !== 404) {
            throw e;
          }
        });
    },
    methods: {
      sendResetPasswordRequest() {
        this.$store
          .dispatch('api/candidateAccount/sendEmailForForgotPassword', {
            email: this.resetPasswordEmail,
          })
          .then((response) => {
            if (response.status === 200) {
              this.$emit('close-dialog');
              this.$notifications.showNotification({
                message: this.$t('forgot.password.send_email_success'),
                color: 'success',
                timeout: 5000,
              });
              //this.$emitWithClientData(Events.UserPasswordForgot, {});
              this.$emitWithClientData(
                this.matomoEventName + 'ForgetPassword',
                true
              );
            }
          })
          .catch((e) => {
            if (e.response.status !== 400) {
              this.$emit('close-dialog');
              this.$emitWithClientData(
                this.matomoEventName + 'ForgetPassword',
                false
              );
              this.$notifications.showNotification({
                message: this.$t('forgot.password.send_email_success'),
                color: 'success',
                timeout: 5000,
              });
              throw e;
            }
            this.$notifications.showNotification({
              message: this.$t('forgot.password.send_email_warning'),
              color: 'warning',
              timeout: 5000,
            });
          });
      },
    },
  };
